export default __webpack_public_path__ + "a714d4882d039be9854b181481ec653d.svg";